var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12 1a1 1 0 0 1 1 1v1.09c2.84.48 5 2.22 5 4.91a1 1 0 1 1-2 0c0-1.66-1.9-3-4-3s-4 1.12-4 2.5c0 1.54 1.93 2.03 4.23 2.63C14.9 10.79 18 11.63 18 15c0 2.69-2.16 4.43-5 4.91V21a1 1 0 1 1-2 0v-1.09c-2.84-.48-5-2.22-5-4.91a1 1 0 1 1 2 0c0 1.66 1.9 3 4 3s4-1.12 4-2.5c0-1.77-2.08-2.3-4.47-2.93C9.15 11.97 6 11.08 6 8c0-2.69 2.16-4.43 5-4.91V2a1 1 0 0 1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.8dffaab1fc4a47b95b57c7473435e44a.svg";
export { ForwardRef as ReactComponent };